import TemplateDetailsPage from "components/pages/TemplateDetailsPage";

export default function CaptureAddNewTypeModal(props) {
  return (
    <TemplateDetailsPage />
  )
}
